// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__35NG_","rootSmall":"AddTileButton_rootSmall__1OQsQ"};